var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eqGoBPdYrep1",
    textRendering: "geometricPrecision",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406 440.2",
    style: {
      enableBackground: "new 0 0 406 440.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.offline0{fill:#460052;}\n\t.offline1{fill:#731586;}\n\t.offline2{fill:#25002E;}\n\t.offline3{fill:#FDCBC7;}\n\t.offline4{fill:#D4E3FF;}\n\t.offline5{fill:#E49195;}\n\t.offline6{fill:#F0ACAE;}\n\t.offline7{fill:#39003C;}\n\t.offline8{fill:#FFF5F5;}\n\t.offline9{fill:#7E4800;}\n\t.offline10{fill:#683900;}\n\t.offline11{fill:#38003D;}\n\t.offline12{fill:#CF8200;}\n\t.offline13{opacity:0.6;fill:#EFA841;enable-background:new    ;}\n\t.offline14{fill:#FAEBEA;}\n\t.offline15{fill:#FFFFFF;}\n\t.offline16{fill:url(#eqGoBPdYrep121_00000087397049556821456290000011148194815803058868_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "404.8,184.6 377.3,340.4 372,344.1 368.7,346.4 365.5,348.7 346.7,361.8 346,362.3 334.4,370.4 329.4,374  325.6,376.6 323.1,378.3 313.9,384.8 308.2,388.8 308.1,388.8 302.8,392.5 290.4,401.2 280.7,408 273.3,413.2 272,414.1 269.3,416  249.3,430 247.7,431.1 155.6,414.9 147.9,413.5 124.3,409.3 99.8,405 95.4,404.2 91.9,403.6 51.3,345.6 51.3,345.6 1.2,274  28.7,118.2 126.7,49.6 135.7,43.3 142.2,38.8 158.3,27.5 162.4,28.2 186.3,32.5 213.4,37.2 248.9,43.5 248.9,43.5 257.5,45  272.9,47.8 314.1,55  "
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.733633 0)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "offline0",
    points: "290.4,401.2 280.7,408 273.3,413.2 272,414.1 269.3,416 249.3,430 247.7,431.1 155.6,414.9  147.9,413.5 124.3,409.3 132.4,385.4 277.7,385.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline1",
    points: "188.9,385.4 157.2,394.3 147.9,413.5 124.3,409.3 132.4,385.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline2",
    points: "290.4,401.2 280.7,408 273.3,413.2 272,414.1 269.3,416 270.8,403.4 255.9,385.4 277.7,385.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline3",
    points: "236.8,400.5 232.3,400.5 230.1,404.4 232.3,408.3 236.8,408.3 239.1,404.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline3",
    points: "249.2,400.5 244.7,400.5 242.4,404.4 244.7,408.3 249.2,408.3 251.4,404.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline4",
    points: "260.7,400.5 256.2,400.5 254,404.4 256.2,408.3 260.7,408.3 263,404.4  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "eqGoBPdYrep93_to",
    transform: "translate(305.720047,255.610046)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-305.720047,-280.610046)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "offline3",
    d: "M357.5,237.8l-1.2,4.9l-17.8,15.4l-11.5,11l-9.1,9.3l-0.8,2.5l3.2,1.9l6.6-0.8l4.5,1.6l1.5,2.5l1.7,3 l-0.3,0.7l-0.5,1.2l-2.8,6l-1.4,3l-0.3,0.7l-0.2,0.4l2,2.6l0.9,1.2l0.9,1.2l-0.5,4.4l-8.3,7.7l-6.4,4l-7.1,2.2l-7.7,8.2 L294,339l-5.2,6.5l-0.3,0.4L267,331.1l-13-12.7l2.5-4.7l2.5-4.6l1.5-2.7l0.1-0.2l0.6-1.2l7.8-11.5l9.4-14l5.4-10.6l8.2-11 c0,0,12.9-20.4,13.2-20.5c0.3-0.1,6.5-9,6.5-9l8-10.3l5.2-2.8l1.9,1.8l1.3,1.2l-0.4,7.7l-6.7,11.3l-6.4,10.6l-6.4,12.5 l-1.7,5.6l1.4,3.1l17.4-16l12.1-8.4l11.7-9l4-1.3l0.8-0.2l2.1,2L357.5,237.8L357.5,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline5",
    d: "M289.3,340.7l5.7-8.5l-2-8.8l3.5-14.7l3-8.3l32.5,4.5l0.9,1.2l-0.5,4.4l-8.3,7.7l-6.4,4l-7.1,2.2 l-7.7,8.2L294,339l-5.2,6.5L289.3,340.7L289.3,340.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline6",
    d: "M316.7,279.1l1.9-4.5l7.5-9.1l4.5-6.1l11.2-7.8l7.3-6.6l6.6-8.8l1.6,1.6l-1.2,4.9l-17.8,15.4l-11.5,11 l-9.1,9.3l-0.8,2.5L316.7,279.1L316.7,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline6",
    d: "M301.8,267.2l2-8.9l4.6-4.9l5.4-12l3.5-6.1l6.9-9.2l2.6-8.9l1.3,1.2l-0.4,7.7l-6.7,11.3l-6.4,10.6 l-6.4,12.5l-1.7,5.6l1.4,3.1l-1.4,7.4l-3.5,0.9L301.8,267.2L301.8,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline6",
    d: "M289.8,289l2.6-0.9l-3.2-7.2l4.4-8.6l2.2,7.2l4.5,6.4l4.7-1.9l4,2.7l2.1,6.7l11.2-2.6l6.5-6l4.1,1.3 l1.7,3l-3.6,8l-14.4,3.6l-32.2-8.9L289.8,289L289.8,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline6",
    d: "M288.2,307.8l41-8.4l0.4,0.5l-0.5,1.1l3.8,5l-0.5,4.4l-8.3,7.7l-6.4,4l-7.1,2.2l-6.2,0.4l-4.2-5.2l1-3.8 l-1.9-1.3l-2-6.9l-2.6,1.1l2,0.1l-5.6,5.8l-11.3-1l-6.4-3.7L288.2,307.8L288.2,307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline7",
    d: "M266.7,300.9l5.1-5.3l-4.8,3.2l1.8-3.7l-1.3,0.9l-3.4,4.8l-0.8,1.6l-1,1.4l-0.8,1.2l-1,1.1l0,0l-0.1,0.2 l-0.6,1l-0.9,1.7l-1.4,2.8l0.6,0.5l1.5-2.8l1.5,2.5l7.4-6.8l-2.8-1L266.7,300.9L266.7,300.9z M268.1,305.3l-6.9,6.4l-1.5-2.6 l-1.5,3l-0.3-0.2l2.2-4.4l0.7-1.2l1-1.1l0.8-1.2l1-1.5l0.8-1.6l3.4-4.7l0.5-0.4l-1.8,3.6l3.9-2.6l-3.8,3.9l-1,3.6L268.1,305.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline7",
    d: "M268.4,295.1l0.4-0.9l0.8-1l-0.6,1.7L268.4,295.1L268.4,295.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline7",
    d: "M263.8,305.5l0.8-1.3l0.1-0.5l-0.3,0.1l-0.1-0.2l0.6-0.2l-0.2,0.9l-0.8,1.3L263.8,305.5L263.8,305.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline7",
    d: "M265.3,302.3l-0.2-0.1l0.8-1l0.1-0.4h-0.1l-0.2,0.2l-0.1-0.2l0.3-0.2l0.4,0.1l-0.1,0.6L265.3,302.3 L265.3,302.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline5",
    d: "M308,314.2l6.4-3l4-3.3l-10.4-1.4h3.3l9.6-0.8l9.8-1.9l-10.9,4.9l-4,3.1l-7.7,3.2l-6.9,0.9L308,314.2 L308,314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline3",
    d: "M276.2,292.1l5.7-1.3l4.8-1.1l11.1,0.1l8.8,0.1l8.9-1.5l8.9-0.3l9.7,1.7l4.1,3.9l-0.1,4.6l-3.1,4.1 l-15,4.9l-12,0.2l-10.6,1l-10,4.8l-14.7-1.2l-3.2-3.1L276.2,292.1L276.2,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline8",
    d: "M333.2,290.5l3.7,3.5l-0.3,4.9l-2.8,2.5l-2,0.3l-3.7-1.5v-5.4l1.8-3.7L333.2,290.5L333.2,290.5z"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "eqGoBPdYrep110_to",
    transform: "translate(200.779991,139.470009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200.779991,-165.470009)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "offline9",
    points: "269.9,131.8 272.1,147.9 269,154.9 264.5,161.7 261.5,166.2 193.9,141 171.5,185.6 148,185.6  142,169.2 142,151.4 137.2,147.5 137.2,140.7 133.7,126.3 143.7,117 146.4,103.2 153.5,92.5 153.5,99.4 160.4,92.3 160.4,92.2  170,82.4 189.2,78 202,72.4 225.8,75.5 225.8,81.4 242.5,82.3 259,90 254.7,99.4 263.1,104.1 273.5,117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline10",
    points: "269.9,131.8 272.1,147.9 269,154.9 264.5,161.7 238.6,140.2 226.5,132.8 234.1,123.1 230.3,115.8  230.3,107.1 222.4,99 216.4,99 206.4,87.9 193.3,83.4 173.4,83.4 160.4,92.2 170,82.4 189.2,78 202,72.4 225.8,75.5 225.8,81.4  242.5,82.3 259,90 254.7,99.4 263.1,104.1 273.5,117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline3",
    points: "270,182.4 264.3,209.6 261.6,215.9 245.2,215.4 226.1,214.8 208.1,217.4 183.8,209.4 165.9,195.6  150.4,213.6 136.6,207.3 128.2,185.2 135.3,171.2 146.2,169.2 156.1,179.3 165.1,179.3 168.1,155 162.1,134.1 182,124.7  207.8,131.5 226.5,132.8 235.5,133.5 252.8,126.8 266,144.3 268.1,157.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "offline11",
    d: "M250.8,172.5c0,0,2.6-4.3,8.7-3.4c6,0.9,8.1,4.6,6.5,9s-4.3,6.2-6.7,4.7s-3.8-1.9-3-7.9 c-3.7,0-6.7,2-6.6,0.5S250.8,172.5,250.8,172.5L250.8,172.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline6",
    points: "270,182.4 264.3,209.6 261.6,215.9 245.2,215.4 231.3,206.3 234.4,199.4 245.8,185.6 236.8,171.1  236.8,143.7 226.5,132.8 235.5,133.5 252.8,126.8 266,144.3 268.1,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline12",
    points: "265.7,219.1 263.8,229.2 263.4,241.1 255.4,251.2 240.7,256.6 228.9,258.5 201.4,258.5  180.4,247.3 170.6,236.8 164.3,233.4 156.4,218.9 156.4,203.3 156.3,196.5 156.1,179.3 165.1,179.3 166,192.6 178.1,200.2  187.9,207.2 201.6,207.2 219.5,205.8 230.9,201.9 239.9,202.1 247.9,204.5 252.9,209.3 263.3,213.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "eqGoBPdYrep118",
    className: "offline13",
    points: "265.7,219.1 263.8,229.2 263.4,241.1 255.4,251.2 240.7,256.6 228.9,258.5  201.4,258.5 180.4,247.3 170.6,236.8 164.3,233.4 156.4,218.9 156.4,203.3 156.3,196.5 162.9,208.7 177.9,223.7 201.4,230.3  219.7,241.4 248.3,234.5 254.6,224.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "eqGoBPdYrep119",
    className: "offline14",
    points: "128,185.6 142.9,200 156.5,206.6 150.1,213.9 136.3,207.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "offline15",
    points: "139.8,209.2 142,210.2 141.4,213.5 143.1,216.7 146.3,215.2 147.6,209.8 146.9,206.6 149.7,211.6  148.4,216.7 143.9,220.2 138.9,217.5 138.5,212.1  "
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eqGoBPdYrep121_00000145761598047147082930000005644909222319185565_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.4672,
    y1: 711.4,
    x2: 205.4672,
    y2: 465.7,
    gradientTransform: "matrix(1 0 0 1 -1.4672 -326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "eqGoBPdYrep121",
    style: {
      fill: "url(#eqGoBPdYrep121_00000145761598047147082930000005644909222319185565_)"
    },
    points: " 132.4,385.4 74.7,182.6 188.9,139.7 285.5,149.4 333.3,195.5 277.7,385.4  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.15561921f136f1b04c2ecf5acd28bb1c.svg";
export { ForwardRef as ReactComponent };